import React from "react";

function custom_getvalue(newVal, oldVal) {
  if (newVal === oldVal) {
    return "";
  } else {
    return newVal;
  }
}

export default custom_getvalue;
